import React from "react";
import {
    Container,
    Typography,
    Box,
    Paper,
    Grid,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import GavelIcon from "@mui/icons-material/Gavel";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import PublicIcon from "@mui/icons-material/Public";
import ChecklistIcon from "@mui/icons-material/Checklist";
import LanguageIcon from "@mui/icons-material/Language";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import { useTranslation } from "react-i18next";

const UserSupportPage: React.FC = () => {
    const { t } = useTranslation();
    return (
        <Container maxWidth="lg" sx={{ py: 6 }}>
            <Typography variant="h4" fontWeight={700} gutterBottom>
                {t("user_support_page.title")}
            </Typography>

            {/* Сопровождение иностранных заказчиков */}
            <Paper sx={{ p: 4, mb: 4 }}>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                    {t("user_support_page.foreign_customers.title")}
                </Typography>

                <List>
                    <ListItem>
                        <ListItemIcon><PersonIcon color="primary" /></ListItemIcon>
                        <ListItemText primary={t("user_support_page.foreign_customers.personal_manager")} />
                    </ListItem>
                </List>

                <Typography variant="subtitle1" fontWeight={600} sx={{ mt: 2 }}>
                    {t("user_support_page.foreign_customers.full_support_title")}
                </Typography>
                <List>
                    <ListItem sx={{
                        display: "list-item",
                        listStyleType: "disc",
                        ml: 3 // отступ слева, чтобы маркеры были видны
                    }}
                    ><ListItemText primary={t("user_support_page.foreign_customers.multilingual_consultations")} /></ListItem>
                    <ListItem sx={{
                        display: "list-item",
                        listStyleType: "disc",
                        ml: 3 // отступ слева, чтобы маркеры были видны
                    }}
                    ><ListItemText primary={t("user_support_page.foreign_customers.tender_documentation")} /></ListItem>
                    <ListItem sx={{
                        display: "list-item",
                        listStyleType: "disc",
                        ml: 3 // отступ слева, чтобы маркеры были видны
                    }}
                    ><ListItemText primary={t("user_support_page.foreign_customers.contract_templates")} /></ListItem>
                    <ListItem sx={{
                        display: "list-item",
                        listStyleType: "disc",
                        ml: 3 // отступ слева, чтобы маркеры были видны
                    }}
                    ><ListItemText primary={t("user_support_page.foreign_customers.international_standards")} /></ListItem>
                    <ListItem sx={{
                        display: "list-item",
                        listStyleType: "disc",
                        ml: 3 // отступ слева, чтобы маркеры были видны
                    }}
                    ><ListItemText primary={t("user_support_page.foreign_customers.procurement_publication")} /></ListItem>
                    <ListItem sx={{
                        display: "list-item",
                        listStyleType: "disc",
                        ml: 3 // отступ слева, чтобы маркеры были видны
                    }}
                    ><ListItemText primary={t("user_support_page.foreign_customers.online_meetings")} /></ListItem>
                    <ListItem sx={{
                        display: "list-item",
                        listStyleType: "disc",
                        ml: 3 // отступ слева, чтобы маркеры были видны
                    }}
                    ><ListItemText primary={t("user_support_page.foreign_customers.contract_support")} /></ListItem>
                    <ListItem sx={{
                        display: "list-item",
                        listStyleType: "disc",
                        ml: 3 // отступ слева, чтобы маркеры были видны
                    }}
                    >
                        <ListItemText primary={t("user_support_page.foreign_customers.international_reports")} />
                    </ListItem>
                    <ListItem sx={{
                        display: "list-item",
                        listStyleType: "disc",
                        ml: 3 // отступ слева, чтобы маркеры были видны
                    }}
                    >
                        <ListItemText primary={t("user_support_page.foreign_customers.supplier_verification")} />
                    </ListItem>
                </List>
                <Typography variant="subtitle1" fontWeight={600} sx={{ mt: 2 }}>
                    {t("user_support_page.foreign_customers.legal_support_title")}
                </Typography>
                <Typography variant="subtitle1" sx={{ mb: 2, mt: 2 }}>
                    {t("user_support_page.foreign_customers.legal_support_description1")}
                </Typography>
                <Typography variant="subtitle1" sx={{ mb: 2, mt: 2 }}>
                    {t("user_support_page.foreign_customers.legal_support_description2")}
                </Typography>

                <Typography variant="subtitle1" fontWeight={600} sx={{ mt: 2 }}>
                    {t("user_support_page.foreign_customers.financial_audit_title")}
                </Typography>
                <Typography variant="subtitle1" sx={{ mb: 2, mt: 2 }}>
                    {t("user_support_page.foreign_customers.financial_audit_description1")}
                </Typography>
                <Typography variant="subtitle1" sx={{ mb: 2, mt: 2 }}>
                    {t("user_support_page.foreign_customers.financial_audit_description2")}
                </Typography>
                <Typography variant="subtitle1" sx={{ mb: 2, mt: 2 }}>
                    {t("user_support_page.foreign_customers.financial_audit_description3")}
                </Typography>
                <Typography variant="subtitle1" sx={{ mb: 2, mt: 2 }}>
                    {t("user_support_page.foreign_customers.financial_audit_description4")}
                </Typography>

                <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>
                    {t("user_support_page.foreign_customers.services_activation")}
                </Typography>
                <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>
                    {t("user_support_page.foreign_customers.personal_channel")}
                </Typography>
            </Paper>

            {/* Поддержка казахстанских поставщиков */}
            <Paper sx={{ p: 4, mb: 4 }}>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                    {t("user_support_page.kazakh_suppliers.title")}
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    {t("user_support_page.kazakh_suppliers.description")}
                </Typography>

                <Typography variant="subtitle1" fontWeight={600}>{t("user_support_page.kazakh_suppliers.main_directions")}</Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <List dense>
                            <ListItem><ListItemIcon><FilePresentIcon color="primary" /></ListItemIcon><ListItemText primary={t("user_support_page.kazakh_suppliers.registration_instruction")} /></ListItem>
                            <ListItem><ListItemIcon><LanguageIcon color="primary" /></ListItemIcon><ListItemText primary={t("user_support_page.kazakh_suppliers.video_guide")} /></ListItem>
                            <ListItem><ListItemText primary={t("user_support_page.kazakh_suppliers.price_templates")} /></ListItem>
                        </List>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <List dense>
                            <ListItem><ListItemText primary={t("user_support_page.kazakh_suppliers.tender_preparation")} /></ListItem>
                            <ListItem><ListItemText primary={t("user_support_page.kazakh_suppliers.foreign_procurement")} /></ListItem>
                            <ListItem><ListItemText primary={t("user_support_page.kazakh_suppliers.automated_complaints")} /></ListItem>
                        </List>
                    </Grid>
                </Grid>
            </Paper>

            {/* Центр поддержки */}
            <Paper sx={{ p: 4 }}>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                    {t("user_support_page.support_center.title")}
                </Typography>
                <List>
                    <ListItem>
                        <ListItemIcon><SupportAgentIcon color="primary" /></ListItemIcon>
                        <ListItemText primary={t("user_support_page.support_center.online_chat")} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={t("user_support_page.support_center.email")} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={t("user_support_page.support_center.phone")} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={t("user_support_page.support_center.callback")} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={t("user_support_page.support_center.knowledge_base")} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary={t("user_support_page.support_center.multilingual_support")} />
                    </ListItem>
                </List>
            </Paper>
        </Container>
    );
};

export default UserSupportPage;
